(function () {
  document.querySelectorAll('[data-proof-carousel]').forEach(function (carousel) {
    if (carousel.hasAttribute('data-proof-ready')) return;
    carousel.setAttribute('data-proof-ready', '');

    var slides = Array.from(carousel.querySelectorAll('[data-proof-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-proof-dot]'));
    var previous = carousel.querySelector('[data-proof-previous]');
    var next = carousel.querySelector('[data-proof-next]');
    var index = 0;
    var timer;

    if (slides.length < 2) return;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stop() {
      window.clearInterval(timer);
    }

    function start() {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, 6500);
    }

    previous.addEventListener('click', function () {
      show(index - 1);
      start();
    });

    next.addEventListener('click', function () {
      show(index + 1);
      start();
    });

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        show(dotIndex);
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', function (event) {
      if (!carousel.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    show(0);
    start();
  });
})();
